import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'qpx-grid-item-content',
    template: `<ng-content />`,
    styleUrl: './content.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QpxGridItemContent {}
